import Humanize from 'humanize-plus';

export const ATTEMPT_LOCATION = {
  ANY: 'ANY',
  ATHOME: 'ATHOME',
  INCLASS: 'INCLASS',
};

export const TIMER_TYPE = {
  FLEXIBLE: 'FLEXIBLE',
  FIXED: 'FIXED',
};

export const attemptLocationOptions = [
  { key: ATTEMPT_LOCATION.INCLASS, text: 'Classwork', value: ATTEMPT_LOCATION.INCLASS },
  { key: ATTEMPT_LOCATION.ATHOME, text: 'Homework', value: ATTEMPT_LOCATION.ATHOME },
  { key: ATTEMPT_LOCATION.ANY, text: 'Any', value: ATTEMPT_LOCATION.ANY },
];

export const NODE_TYPE = {
  ASSESSMENT: 'ASSESSMENT',
  CHAPTER_ASSESSMENT: 'CHAPTER_ASSESSMENT',
  DIAGNOSTIC: 'DIAGNOSTIC',
  HIDDEN_BASIC: 'HIDDEN_BASIC',
  LEARNING: 'LEARNING',
  LEVEL2: 'LEVEL2',
  LEVEL3: 'LEVEL3',
  PPT_BASIC: 'PPT_BASIC',
  PRACTICE: 'PRACTICE',
  PUZZLE_EASY: 'PUZZLE_EASY',
  PUZZLE_HARD: 'PUZZLE_HARD',
  PUZZLE_MEDIUM: 'PUZZLE_MEDIUM',
  PYTHON_BASIC: 'PYTHON_BASIC',
  PYTHON_VISUAL: 'PYTHON_VISUAL',
  RECAP: 'RECAP',
  REMEDIAL: 'REMEDIAL',
  REVISION: 'REVISION',
  SUBJECTIVE: 'SUBJECTIVE',
  TURING_ASSESSMENT: 'TURING_ASSESSMENT',
  TURING_BASIC: 'TURING_BASIC',
  TURING_LINK: 'TURING_LINK',
  TURING_PRACTICE: 'TURING_PRACTICE',
  TURING_SHARE: 'TURING_SHARE',
  TURING_SUBJECTIVE: 'TURING_SUBJECTIVE',
  TARGET_PRACTICE: 'TARGET_PRACTICE',
  TRIAL_DIAGNOSTIC: 'TRIAL_DIAGNOSTIC',
  TRIAL_BASIC: 'TRIAL_BASIC',
  TRIAL_INTERMEDIATE: 'TRIAL_INTERMEDIATE',
  TRIAL_ADVANCED: 'TRIAL_ADVANCED',
  SAT_MATH_LEARNING: 'SAT_MATH_LEARNING',
  SAT_MATH_ASSESSMENT: 'SAT_MATH_ASSESSMENT',
  SAT_ENGLISH_LEARNING: 'SAT_ENGLISH_LEARNING',
  SAT_ENGLISH_ASSESSMENT: 'SAT_ENGLISH_ASSESSMENT',
  SAT_MATH_RECAP: 'SAT_MATH_RECAP',
  SAT_ENGLISH_RECAP: 'SAT_ENGLISH_RECAP',
};

export const nodeTypeOptions = Object.keys(NODE_TYPE)
  .sort()
  .map(nodeType => ({
    key: nodeType,
    text: nodeType
      .split('_')
      .map(val => Humanize.capitalize(val, true))
      .join(' '),
    value: nodeType,
  }));

export const courseTypeOptions = [
  { key: 'PROGRAM', text: 'Program', value: 'PROGRAM' },
  { key: 'TEST_SERIES', text: 'Test Series', value: 'TEST_SERIES' },
];

export const worksheetTypeOptions = [
  { key: 'LEARNOSITY', text: 'Learnosity', value: 'LEARNOSITY' },
  { key: 'PUZZLE', text: 'Puzzle', value: 'PUZZLE' },
  { key: 'PYTHON', text: 'Python', value: 'PYTHON' },
  { key: 'TURING', text: 'Turing', value: 'TURING' },
  { key: 'WB_ACTIVITY', text: 'WB_ACTIVITY', value: 'WB_ACTIVITY' },
];

export const programTypeOptions = [
  {
    key: 'CODING_DEMO_GD',
    text: 'Coding Demo Game Development',
    value: 'CODING_DEMO_GD',
  },
  { key: 'CODING_DEMO_AD', text: 'Coding Demo App Development', value: 'CODING_DEMO_AD' },
  { key: 'CODING_DEMO_PY', text: 'Coding Demo Python', value: 'CODING_DEMO_PY' },
  {
    key: 'CODING_CORE_GD',
    text: 'Coding Core Game Development',
    value: 'CODING_CORE_GD',
  },
  { key: 'CODING_CORE_AD', text: 'Coding Core App Development', value: 'CODING_CORE_AD' },
  {
    key: 'CODING_CORE_PY',
    text: 'Coding Core Python Development',
    value: 'CODING_CORE_PY',
  },
  { key: 'CODING_CORE', text: 'Coding Core', value: 'CODING_CORE' },
  { key: 'CODING_DEMO', text: 'Coding Demo', value: 'CODING_DEMO' },
  { key: 'CODING_ELECTIVES', text: 'Coding Electives', value: 'CODING_ELECTIVES' },
  { key: 'MATH_CORE', text: 'Math Core', value: 'MATH_CORE' },
  { key: 'MATH_DEMO', text: 'Math Demo', value: 'MATH_DEMO' },
  { key: 'MATH_ELECTIVES', text: 'Math Electives', value: 'MATH_ELECTIVES' },
  { key: 'SCIENCE_CORE', text: 'Science Core', value: 'SCIENCE_CORE' },
  { key: 'SCIENCE_DEMO', text: 'Science Demo', value: 'SCIENCE_DEMO' },
  { key: 'SCIENCE_ELECTIVES', text: 'Science Electives', value: 'SCIENCE_ELECTIVES' },
  { key: 'ELA_CORE', text: 'ELA Core', value: 'ELA_CORE' },
  { key: 'ELA_DEMO', text: 'ELA Demo', value: 'ELA_DEMO' },
  { key: 'ELA_ELECTIVES', text: 'ELA Electives', value: 'ELA_ELECTIVES' },
  { key: 'SAT_MATH', text: 'Sat Math', value: 'SAT_MATH' },
  { key: 'SAT_ENGLISH', text: 'Sat English', value: 'SAT_ENGLISH' },
  { key: 'SAT_TESTS', text: 'Sat Mock Test', value: 'SAT_TESTS' },
  { key: 'SAT_DEMO', text: 'Sat Diagnostic Test', value: 'SAT_DEMO' },
  { key: 'ELP_CORE', text: 'ELP Core', value: 'ELP_CORE' },
];

export const collapseHeight = 250;
export const fullHeight = 700;

export const NODE_DEFAULT_DATA = {
  is_timed: false,
  attempt_location: ATTEMPT_LOCATION.INCLASS,
  points_available: 20,
  complete_in: 0,
  node_type: NODE_TYPE.LEARNING,
  sheet_time: 2400,
  is_optional: false,
  unlock_interval: 0,
  reattempt_in: 0,
  completionData: [
    [
      {
        attribute: 'accuracy',
        attributeValue: 50,
        operator: '>=',
      },
    ],
  ],
  reattemptData: [
    [
      {
        attribute: 'accuracy',
        attributeValue: 100,
        operator: '<',
      },
    ],
  ],
  tags: [],
};

export const operatorOptions = [
  { key: '<', text: '<', value: '<' },
  { key: '>', text: '>', value: '>' },
  { key: '=', text: '=', value: '=' },
  { key: '>=', text: '>=', value: '>=' },
  { key: '=<', text: '=<', value: '=<' },
];

export const sheetTimerType = [
  {
    key: 'flexible_selected',
    value: TIMER_TYPE.FLEXIBLE,
    text: TIMER_TYPE.FLEXIBLE,
  },
  {
    key: 'fixed_selected',
    value: TIMER_TYPE.FIXED,
    text: TIMER_TYPE.FIXED,
  },
];
